import {useMemo, useState} from 'react';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import IconButton from '@mui/material/IconButton';
import classnames from 'classnames';

import {MHRegularButton} from '../../buttons';
import MHTextField from '../../MHTextField';
import {buildVisiblePages} from '../utils';

import styles from '../styles/pagination/paginationActions.module.scss';

const PaginationActions = ({count, page, rowsPerPage, onPageChange}) => {
    const [goToPage, setGoToPage] = useState('');

    const pagesCount = Math.max(1, Math.ceil(count / rowsPerPage));
    const pagesArray = [...Array(pagesCount).keys()].map((item) => item + 1);

    const visiblePages = useMemo(() => buildVisiblePages(pagesArray, page), [page, pagesArray]);

    const handleBackButtonClick = (event) => {
        if (page > 0) onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        if (pagesCount > page + 1) onPageChange(event, page + 1);
    };

    const goToPageHandler = () => {
        const goToPageNumber = parseInt(goToPage);

        if (goToPageNumber) {
            onPageChange({}, pagesArray.includes(goToPageNumber) ? goToPageNumber - 1 : pagesCount - 1);
        }
    };

    const handleInputKeyPress = (event) => {
        if (event.key === 'Enter') {
            goToPageHandler();
        }
    };

    return (
        <div className={styles.paginationWrapper}>
            <IconButton
                disabled={page === 0}
                onClick={handleBackButtonClick}
                aria-label="previous page"
                classes={{root: styles.paginationArrow}}
                size="large"
            >
                <KeyboardArrowLeft />
            </IconButton>

            {visiblePages.map((item, index) => (
                <div
                    key={`${item}-${index}`}
                    onClick={(event) => {
                        if (typeof item === 'number') {
                            onPageChange(event, item - 1);
                        }
                    }}
                    className={classnames(
                        styles.paginationItem,
                        {[styles.paginationItemActive]: item === page + 1},
                        {[styles.paginationItemDivider]: typeof item === 'string'}
                    )}
                >
                    {item}
                </div>
            ))}

            <IconButton
                disabled={page === pagesCount - 1}
                onClick={handleNextButtonClick}
                aria-label="next page"
                classes={{root: styles.paginationArrow}}
                size="large"
            >
                <KeyboardArrowRight />
            </IconButton>

            <div className={styles.goToPage__wrapper}>
                <div className={styles.goToPage__title}>Go to page</div>

                <MHTextField
                    rootClassName={styles.goToPage__inputWrapper}
                    inputBaseClasses={{input: styles.goToPage__input}}
                    onKeyPress={handleInputKeyPress}
                    value={goToPage}
                    onChange={({target}) => {
                        setGoToPage(target.value);
                    }}
                />

                <MHRegularButton
                    text="Go"
                    onClick={goToPageHandler}
                    btnType="secondary-positive"
                    btnSize="small"
                    margin="0 0 0 8px"
                />
            </div>
        </div>
    );
};

export default PaginationActions;
